import { MenuSettingsPage } from '@repo/ui/features/superadmin';

export default function SuperAdminMenusPage() {
  return (
    <div className="w-full py-6">
      <MenuSettingsPage />
    </div>
  );
}
